import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router, Event, NavigationEnd, NavigationStart, NavigationError } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

import { Observable } from 'rxjs';
import { map, switchMap, filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { SchedulerService } from '../scheduler.service';
import { EventShowStatus, ApiResponseCode, TreatmentStatus, ConfirmBoxAction } from 'src/app/core/enums';
import moment from 'moment';
import { ConfirmBoxComponent } from '../../confirm-box/confirm-box.component';
import { AppointmentModel } from 'src/app/core/models/appointment-model';
import { Location } from '@angular/common';

import { FindTimeService } from 'src/app/core/services/find-time.service';
import { VisitItem } from 'src/app/core/models/visit-item';
import { FindTimeModel } from 'src/app/core/models/find-time-model';
import { FindTimeResultItem } from 'src/app/core/models/find-time-result-item-model';
import { AppData } from 'src/app/app.data';
import { CustomerDetails } from 'src/app/core/models/customer-details';
import { CustomerService } from 'src/app/core/services/customer.service';
import { Utils } from 'src/app/core/utils';
import { MatSortable } from '@angular/material/sort';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { AvailableBalanceDialogComponent } from '../../available-balance-dialog/available-balance-dialog.component';


@Component({
  selector: 'app-future-visits',
  templateUrl: './future-visits.component.html',
  styleUrls: ['./future-visits.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class FutureVisitsComponent implements OnInit {
  customerID: number;
  customerName: string;
  customer: CustomerDetails;
  displayedColumns: string[] = ['details', 'date', 'symbol'];
  
  expendedElement:VisitItem | null;
  error = '';
  abbrevaite: boolean = true;
  public dataSource = new MatTableDataSource<VisitItem>([]);
  expandedElement: VisitItem | null;


  settings: Settings;
  returnUrl: string;
  public toggleFutureEvents: string = 'future';
  previousUrl: string;


  constructor(
    private appSettings: AppSettings,
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private translate: TranslateService,
    private schedulerService: SchedulerService,
    private customerService: CustomerService,
    public dialog: MatDialog,
    private location: Location,
    private findtimeService: FindTimeService,
    private appData: AppData,
    private authService: AuthenticateService) {

    this.settings = appSettings.settings;
    this.settings.loadingSpinner = true;
  }



  ngOnInit() {
    // when pressing on menu item
     const patient = this.appData.patient;
     if (patient) {
       this.customerID = patient.ID;
       this.customerName = patient.Name;
       this.getCustomerDetails(this.customerID);

     } else {
       this.customerID = +(this.route.snapshot.paramMap.get('customerid') || '0');
     }

     if (this.customerID > 0) {
       this.loadEvents();
     } else {
       alert('Invalid customerID');
     }
  }

  getCustomerDetails(customerID: number) {
    this.customerService.getDetails(customerID).subscribe(result => {
      if (result.Code === ApiResponseCode.Success) {
        this.customer = new CustomerDetails(result.Data.customer);
        this.appData.customerDetails = this.customer; // send customerData to appData 

      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    }, error => {
      this.error = error;
    });
  }

  onToggleChange(e) {
    this.toggleFutureEvents = e.value;
    this.loadEvents();
  }

  loadEvents() {
    if (this.toggleFutureEvents === 'future') {
      this.getFutureEvents();
    } else {
      this.getHistoryEvents();
    }
  }


  visitReasonSummary(ev) {
    return Utils.generateVisitReasonSummary1(ev.Treatments, this.translate, this.abbrevaite);
  }

  getFutureEvents() {

    if (this.customerID == 0) {
      alert('Invalid customerID');
      return;
    }


    this.settings.loadingSpinner = true;
    this.dataSource = new MatTableDataSource<VisitItem>([]);

    this.error = '';
    this.schedulerService.loadCustomerEvents(this.customerID, EventShowStatus.Future)
      .subscribe(result => {
        this.settings.loadingSpinner = false;
        if (result.Code == ApiResponseCode.Success) {
          const data = result.Data.map(x => new VisitItem(x));
          this.dataSource = new MatTableDataSource<VisitItem>(data);
          this.sortDataSource();
          this.setEvenOddColumn();
        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      }, error => {

        this.settings.loadingSpinner = false;
        this.error = error;
      });
  }

  

  sortDataSource() {
    

    let dir = this.toggleFutureEvents === 'future' ?  'asc' : 'desc';



    if (dir === 'desc') {
      //this.dataSource.sort.sort(<MatSortable>({ id: id, start: start }));
      this.dataSource.data.sort((a: VisitItem, b: VisitItem) => {
        if (a.StartAt < b.StartAt) {
          return 1;
        } else if (a.StartAt > b.StartAt) {
          return -1;
        } else {
          return 0;
        }
      });
    }
    else {
      //this.dataSource.sort.sort(<MatSortable>({ id: id, start: start }));
      this.dataSource.data.sort((a: VisitItem, b: VisitItem) => {
        if (a.StartAt < b.StartAt) {
          return -1;
        } else if (a.StartAt > b.StartAt) {
          return 1;
        } else {
          return 0;
        }
      });
    }


  }

  setEvenOddColumn(){
     for (let index = 0; index < this.dataSource.data.length; index++) {
      const element = this.dataSource.data[index];
      element.even = index % 2 == 0;
      
     } 
  }

  getHistoryEvents() {
    this.dataSource = new MatTableDataSource<VisitItem>([]);

    this.settings.loadingSpinner = true;
    this.schedulerService.loadCustomerEvents(this.customerID, EventShowStatus.History).subscribe(result => {
      this.settings.loadingSpinner = false;
      if (result.Code == ApiResponseCode.Success) {       
        this.dataSource = new MatTableDataSource<VisitItem>(result.Data);
        this.sortDataSource();
        this.setEvenOddColumn();

      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    }, error => {

      this.settings.loadingSpinner = false;
      this.error = error;
    });
  }

  back() {
    // this.router.navigate(['/scheduler']);
    this.location.back();
  }

  removeRow(item) {
    let index: number = this.dataSource.data.findIndex(d => d === item);
    this.dataSource.data.splice(index, 1);
    this.dataSource = new MatTableDataSource<VisitItem>(this.dataSource.data);
    
  }


  openDialog(event: VisitItem) {

    const title = this.translate.instant('CONFIRM.DELETE-APP-TITLE');
    const msg = this.translate.instant('CONFIRM.DELETE-APP-MSG', {
      name: this.customerName,
      date: moment(event.StartAt).format('L'), // date
      time: moment(event.StartAt).format('LT') // time
    });


    // open dialog
    const dialogRef = this.dialog.open(ConfirmBoxComponent, {
      width: '300px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {
        actionType: ConfirmBoxAction.DeleteAppointment,
        title: title,
        message: msg,
        cancelReasonID: 0,
        cancelReason: ''
      }
    });

    // delete if user click the Ok button
    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        // ok
        const model = new AppointmentModel();
        model.EventID = event.ID;
        model.CancelReasonID = result.cancelReasonID;
        model.CancelReason = result.cancelReason;

        if (model.CancelReasonID > 0) {
          this.schedulerService.deleteEvent(model).subscribe(response => {
            if (response.Code === ApiResponseCode.Success) {
              // item deleted 
              this.removeRow(event);

            } else {
              this.error = this.translate.instant(`ERROR.CODE.${response.Code}`);
            }
          }, error => {
            this.error = error;
          });
        }
      }
    });
  }


  delete(event: VisitItem) {
    // Check if deletion is prevented by claim
    if (this.authService.claims.PreventAppointmentCancellation) {
      this.showNoPermissionDialog();
      return;
    }

    if (!this.appData.cancelReasons || this.appData.cancelReasons.length === 0) {
      // reload cacnel reasons
      this.schedulerService.getCancelReasons().subscribe(result => {
        // the service populate 'appSettings.CancelReasons'
        if (result.Code === 1) {
          this.openDialog(event);
        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      },
        error => {
          this.error = error;
        });
    } else {
      this.openDialog(event);
    }
  }

  editAppointment(item: VisitItem) {
    this.appData.selectedFindTimeResultItem = null;
    this.appData.selectedFindTimeResultItemGroup = null;
    this.appData.formStateFindTime = null;
    this.appData.appointment = null;
    this.appData.bookAppointment = null;
    this.appData.bookVisitItem = null;
    this.appData.visitItem = item;

    this.router.navigate(['/appointment-details', item.ID]);
  }

  moveAppointment(item: VisitItem) {
    // Check if time change is prevented by claim
    if (this.authService.claims.PreventAppointmentTimeChange) {
      this.showNoPermissionToChangeTimeDialog();
      return;
    }

    const eventId = item.ID;
    this.schedulerService.getEvent(eventId).subscribe(
      result => {
        if (result.Code === 1) {
          // success
          let appointment = new AppointmentModel(result.Data);

          if (this.appData.appointment && this.appData.appointment.EventID === appointment.EventID) {
            appointment = new AppointmentModel(this.appData.appointment);

          } else {
            this.appData.appointment = appointment;
          }

          // get roomID of appointment by EventID
          this.schedulerService.getEventRoomInfo(eventId).subscribe(roomResult => {
            if (roomResult.Code === ApiResponseCode.Success) {
              appointment.SchedulerRoomID = roomResult.Data ? roomResult.Data.SchedulerID : 0;
              this.appData.appointment = appointment;
              this.router.navigate(['/find-time']);
            }
          });



        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      },
      error => {
        this.error = error;
      }
    );
  }


  bookAppointment(item: VisitItem) {

    // change retro date to current date
    const customerID = item.CustomerID;
    const newItem = new VisitItem(item);
    const hours = newItem.StartAt.hours();
    const minutes = newItem.StartAt.minutes();
    newItem.StartAt = moment().startOf('day');  // clear time
    newItem.StartAt.add(hours, 'hours').add(minutes, 'minutes'); // add time

    // clear find time previous data
    this.appData.selectedFindTimeResultItem = null;
    this.appData.selectedFindTimeResultItemGroup = null;
    this.appData.formStateFindTime = null;

    this.appData.bookAppointment = this.appData.appointment;
    this.appData.bookVisitItem = newItem;
    this.appData.appointment = null;
    this.appData.visitItem = null;


    // save priceListCodes to generate new appointment based on the treatments done in previous appointment.
    this.appData.treatments = null;
    this.appData.priceListCodes = item.Treatments.map(x => {
      var pricelistCode = x.PriceListCode;
      pricelistCode.FinalPrice = x.Price || 0;
      pricelistCode.PriceListRefID = x.PriceListRefID || 0;
      pricelistCode.PriceListID = x.PriceList && x.PriceList.ID || 0;
      return pricelistCode;
    });

    // build model to find time
    const model = new FindTimeModel(newItem);
    model.Date = moment().startOf('day');  // clear time
    model.StartTime = '00:00';
    model.EndTime = '23:00';
    model.ExpertiesID = `${newItem.TherapistPracticeID}`;
    model.FirstDayOfWeek = this.appSettings.settings.firstDayOfWeek;
    model.SchedulerIDForUser = `${newItem.SchedulerID}`;
    if (!newItem.Treatments || newItem.Treatments.length === 0) {
      model.PriceListRefIds = '';
    } else {
      model.PriceListRefIds = newItem.Treatments.map(x => x.PriceListRefID).toString();
    }



    this.findtimeService.findTimeGroup(model).subscribe(result => {
      if (result.Code === ApiResponseCode.Success) {
        this.appData.findTimeCancelButtonRoute = 'patient-details/' + customerID; // set findtime cancel btn route to patient details.
        this.appData.findTimeGroupResult = result.Data.map(item => new FindTimeResultItem(item));
        this.showResult();

      } else {
        this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
      }
    }, error => {
      this.error = error;
    });

  }

  showResult() {
    this.router.navigate(['/find-time-group-result']);
  }


  canBeDeleted(appointment) {
    // do not allow to delete an appointment when has Done treatments.

    if (appointment.Arrived === false) {
      return false;
    }

    if (appointment.Treatments && appointment.Treatments.length > 0) {
      return appointment.Treatments.filter(x => x.TreatmentStatusID === TreatmentStatus.Done).length === 0;
    }
    return false;
  }

  canBookAppointment(appointment: VisitItem) {

    // allow to book appointment based on current visit only if pricelist and priceListCode are active.
    return appointment.CanBeBooked;


    // if(appointment.Treatments && appointment.Treatments.length > 0 ){
    //   return appointment.Treatments.filter(x=> x.PriceList.Active !== true || x.PriceListCode.Active).length > 0;
    // }
    // return false;
  }

  showNoPermissionDialog() {
    const msg = this.translate.instant('MSG.NO-PERMISSION-TO-CANCEL-APPOINTMENT');

    const dialogRef = this.dialog.open(AvailableBalanceDialogComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {
        message: msg,
        hideCancel: true
      }
    });
  }

  showNoPermissionToChangeTimeDialog() {
    const msg = this.translate.instant('MSG.NO-PERMISSION-TO-CHANGE-APPOINTMENT-TIME');

    const dialogRef = this.dialog.open(AvailableBalanceDialogComponent, {
      width: '400px',
      direction: (this.settings.rtl ? 'rtl' : null),
      data: {
        message: msg,
        hideCancel: true
      }
    });
  }
}





